'use strict';

exports.__esModule = true;
exports.default = exports.Close = exports.Footer = exports.Tertiary = exports.Secondary = exports.Main = exports.Header = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactPortal = require('react-portal');

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fadeIn = (0, _styledComponents.keyframes)(['from{opacity:0;,}to{opacity:1;}']);

var Backdrop = _styledComponents2.default.dialog.withConfig({
  displayName: 'Modal2__Backdrop'
})(['position:fixed;top:0;left:0;z-index:2000;display:flex;flex-direction:column;justify-content:center;width:100%;height:100%;padding:4rem;border:0;background-color:', ';animation:0.3s ', ';'], _styles2.default.backdropColor, fadeIn);

var Window = _styledComponents2.default.div.withConfig({
  displayName: 'Modal2__Window'
})(['position:relative;display:flex;flex-direction:column;z-index:2001;max-width:600px;min-width:300px;height:auto;min-height:240px;max-height:100%;overflow:hidden;margin:0 auto;padding:2rem 0;width:100%;background-color:white;box-shadow:0 0.25rem 1rem ', ';'], _styles2.default.backdropColor);
var Header = exports.Header = _styledComponents2.default.header.withConfig({
  displayName: 'Modal2__Header'
})(['font-family:\'Open Sans\',\'Helvetica Neue\',Helmet,Freesans,sans-serif;font-size:16px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.5;letter-spacing:0.5px;color:', ';border-bottom:1px solid ', ';padding:1rem 6rem 20px 6rem;'], _styles2.default.grayDark, _styles2.default.grayLighter);
var Main = exports.Main = _styledComponents2.default.main.withConfig({
  displayName: 'Modal2__Main'
})(['position:relative;flex:1 1;width:100%;min-height:64px;font-family:\'Open Sans\',\'Helvetica Neue\',Helmet,Freesans,sans-serif;font-size:20px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:1.6;letter-spacing:0.5px;color:', ';padding:4rem 6rem;overflow:auto;'], _styles2.default.grayDark);

var Secondary = exports.Secondary = _styledComponents2.default.main.withConfig({
  displayName: 'Modal2__Secondary'
})(['position:relative;flex:1 1;width:100%;min-height:60px;font-family:\'Open Sans\',\'Helvetica Neue\',Helmet,Freesans,sans-serif;font-size:16px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.5;letter-spacing:normal;color:', ';margin:0;padding:4rem 6rem;overflow:auto;h2{text-transform:none;margin:0;}> p:last-child{margin-bottom:0;}'], _styles2.default.grayDark);
var Tertiary = exports.Tertiary = _styledComponents2.default.main.withConfig({
  displayName: 'Modal2__Tertiary'
})(['width:100%;min-height:1rem;font-family:\'Open Sans\',\'Helvetica Neue\',Helmet,Freesans,sans-serif;font-size:16px;font-style:normal;font-stretch:normal;line-height:1.5;letter-spacing:normal;color:', ';flex:1 1;margin:1rem 0 2rem 0;padding:0 6rem;'], _styles2.default.grayDark);

var Footer = exports.Footer = _styledComponents2.default.footer.withConfig({
  displayName: 'Modal2__Footer'
})(['padding:2rem 6rem 0 6rem;border-top:1px solid ', ';width:100%;'], _styles2.default.grayLighter);

var Close = exports.Close = _styledComponents2.default.div.withConfig({
  displayName: 'Modal2__Close'
})(['position:absolute;top:0;right:0;width:6rem;min-height:6rem;margin:2.5rem;color:', ';font-size:4rem;text-align:center;cursor:pointer;transition:color 0.2s;font-weight:300;&:hover{color:', ';}'], _styles2.default.grayLight, _styles2.default.grayDark);

var Modal = (_temp2 = _class = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      documentBodyOverflow: ''
    }, _this.onBackdropClick = function (e) {
      if (e.target === e.currentTarget && _this.props.onClose) {
        _this.props.onClose();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.componentWillMount = function componentWillMount() {
    this.saveDocumentBodyOverflow();
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.handleDocumentOverflow(nextProps);
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    this.restoreDocumentBodyOverflow();
  };

  Modal.prototype.saveDocumentBodyOverflow = function saveDocumentBodyOverflow() {
    this.setState({
      documentBodyOverflow: document.body.style.overflow
    });
  };

  Modal.prototype.handleDocumentOverflow = function handleDocumentOverflow(nextProps) {
    if (this.modalWillOpen(nextProps)) {
      document.body.style.overflow = 'hidden';
    } else if (this.modalWillClose(nextProps)) {
      this.restoreDocumentBodyOverflow();
    }
  };

  Modal.prototype.restoreDocumentBodyOverflow = function restoreDocumentBodyOverflow() {
    document.body.style.overflow = this.state.documentBodyOverflow;
  };

  Modal.prototype.modalWillOpen = function modalWillOpen(nextProps) {
    return !this.props.isOpen && nextProps.isOpen;
  };

  Modal.prototype.modalWillClose = function modalWillClose(nextProps) {
    return this.props.isOpen && !nextProps.isOpen;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        isOpen = _props.isOpen,
        hasClose = _props.hasClose,
        onClose = _props.onClose,
        children = _props.children,
        backdropStyle = _props.backdropStyle,
        windowStyle = _props.windowStyle,
        portalProps = _props.portalProps,
        rest = _objectWithoutProperties(_props, ['isOpen', 'hasClose', 'onClose', 'children', 'backdropStyle', 'windowStyle', 'portalProps']);

    return _react2.default.createElement(
      _reactPortal2.default,
      _extends({ isOpened: isOpen }, portalProps),
      _react2.default.createElement(
        Backdrop,
        _extends({
          onClick: this.onBackdropClick,
          style: backdropStyle
        }, rest),
        _react2.default.createElement(
          Window,
          { style: windowStyle },
          hasClose && onClose && _react2.default.createElement(
            Close,
            { onClick: onClose },
            '\xD7'
          ),
          isOpen && children
        )
      )
    );
  };

  return Modal;
}(_react.Component), _class.defaultProps = {
  backdropStyle: {},
  windowStyle: {},
  hasClose: true,
  portalProps: {}
}, _temp2);
exports.default = Modal;
Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: _propTypes.bool.isRequired,
  onClose: _propTypes.func,
  children: _propTypes.any.isRequired,
  backdropStyle: _propTypes.object,
  windowStyle: _propTypes.object,
  hasClose: _propTypes.bool,
  portalProps: _propTypes.object
} : {};


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Modal2/Modal2.js
// module id = 2261
// module chunks = 14